import { createSlice } from '@reduxjs/toolkit';
import { TNotifyState } from './notify.type';

const initialState: TNotifyState = {
  images: [],
  messages: [],
  semesters: [],
};

export const NotifySlice = createSlice({
  name: 'notify',
  initialState,
  reducers: {},
});

export default NotifySlice.reducer;
